import i18n from "../lang/i18n";
const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  credit: {
    required: true,
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value.trim()),
      message: i18n.t("validation.the_credit_must_be_a_positive_number")
    }
  }
};
export { validations };
